import MapWidget from "../../../../widgets/map/mapWidget/MapWidget";
import { useEffect, useState } from "react";
import { getGeoJSONFeaturesVectorLayer, getAllRoadObjectsLayer } from "../../../../widgets/map/mapFeatures/layers";
import { MapOverlayWidget } from "../../../../widgets/map/mapAddons/mapOverlayWidget";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { useDispatch } from "react-redux";
import useWebSocket from "react-use-websocket";
import { useFetchTransportQuery } from "../../../../api/rtk/base/slices/transportApiSlice";
import { setTransportMonitoringFullList, setTransportMonitoringObject } from "../../../../stateManagement/reducers/transport/TransportNowSlice";
import { clickMapForTransportNow, configureTransportMoveFeaturesList, handleTransportSocketClosed, handleTransportSocketError, handleTransportSocketOpened, hoverMapForTransportNow } from "./mapTransportMonitoringFunctions";
import { useNavigate } from "react-router-dom";
import { transportMonitoringArrowStyle } from "../../../../widgets/map/mapFeatures/styles/mapStyles";
import ContentHeader from "../../../../widgets/contentHeader/ContentHeader";

export function MapTransportMonitoring() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const objectTypeName = "TransportNow"
    const [timer, setTimer] = useState<any>();
    const bbox = useAppSelector(state => state.map.bbox)
    const transportMonitoringObject = useAppSelector(state => state.transportNow.transportMonitoringObject)
    const transportMonitoringCheckReady = useAppSelector(state => state.transportNow.transportMonitoringCheckReady)
    const transportMonitoringShowNumbers = useAppSelector(state => state.transportNow.transportMonitoringShowNumbers)
    const transportMonitoringLastShownFeaturesJson = useAppSelector(state => state.transportNow.transportMonitoringLastShownFeaturesJson)

    const style = (feature: any) => transportMonitoringArrowStyle(feature, transportMonitoringShowNumbers)
    const transportLayer = getGeoJSONFeaturesVectorLayer(transportMonitoringLastShownFeaturesJson, "EPSG:4326", style)
    const roadsLayer = getAllRoadObjectsLayer()
    const [permanentLayers] = useState([roadsLayer])

    const { data: transport } = useFetchTransportQuery({})
    useEffect(() => {
        dispatch(setTransportMonitoringFullList(transport))
    }, [transport])

    const socketUrl = 'wss://geo.indorsoft.ru/carmonitoring';
    const {
        sendMessage,
        readyState,
    } = useWebSocket(socketUrl, {
        onOpen: handleTransportSocketOpened,
        //Will attempt to reconnect on all close events, such as server shutting down
        shouldReconnect: (closeEvent) => true,
        onError: handleTransportSocketError,
        onMessage: (event) => handleTransportSocketMessage(event),
    });

    function handleTransportSocketMessage(event: any) {
        event?.data && dispatch(setTransportMonitoringObject(JSON.parse(event.data)))
    }

    useEffect(() => {
        if (transportLayer) {
            transportLayer.setStyle((feature: any) => transportMonitoringArrowStyle(feature, transportMonitoringShowNumbers))
        }
    }, [transportMonitoringShowNumbers])

    useEffect(() => {
        function updateTransportPosition() {
            if (readyState === 1) {
                sendMessage(
                    JSON.stringify(
                        {
                            boundingBox: bbox,
                            type: "VIEW"
                        }
                    )
                )
            }
        }
        let timerTime = 1500;
        clearTimeout(timer);
        setTimer(setTimeout(function () {
            updateTransportPosition()
        }, timerTime));
    }, [bbox, readyState])

    useEffect(() => {
        if (readyState === 1) {
            sendMessage(
                JSON.stringify({ type: "READY" })
            )
        }
    }, [transportMonitoringCheckReady])

    useEffect(() => {
        if (transportMonitoringObject) {
            configureTransportMoveFeaturesList(transportMonitoringObject, transportLayer, transportMonitoringCheckReady)
        }
    }, [transportMonitoringObject])

    function applyMapTransportInteraction(map: any) {
        const pointerMoveFunc = (event: any) => hoverMapForTransportNow(event, map)
        const transportClick = (event: any) => clickMapForTransportNow(event, map, navigate)
        map?.on("pointermove", pointerMoveFunc)
        map?.on("singleclick", transportClick)
        return {
            off: () => {
                map?.un("pointermove", pointerMoveFunc)
                map?.un("singleclick", transportClick)
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "transportInteraction",
            func: applyMapTransportInteraction
        }
    ]

    useEffect(() => {
        return () => {
            handleTransportSocketClosed()
        }
    }, [])

    return (
        <>
            <ContentHeader title="Карта «Транспортные средства на дороге»" objectTypeName={objectTypeName} type="map" />
            <div className="map-widget-with-toast">
                <MapWidget additionalLayers={[transportLayer]} mapEventHandlers={mapEventHandlers} permanentLayers={permanentLayers} />
                <MapOverlayWidget />
            </div>
        </>
    )
}
